import PersonIcon from '@material-ui/icons/Person';
import { ChallengeCommentsList } from './views';

export default {
  show: ChallengeCommentsList,
  icon: PersonIcon,
  name: 'challenge-comment-report',
};
